<template>
  <div class="not-prose scroll-target" >

    <div v-if="showForm" class="relative md:pt-4">
      <property-search-form
        :terms="terms"
        class="relative z-30 bg-gray-100 dark:bg-primary p-4"
        @submitted="performSearch"
      ></property-search-form>
    </div>

    <div v-if="showMeta && meta.total > 0 || filtering" class="relative">
      <div
        class="bg-gray-100 dark:bg-primary flex flex-wrap md:items-center"
        :class="{
          'p-4': showForm,
          'p-6': !showForm
        }"
      >
        <div class="w-1/2 md:w-auto pr-1.5 xl:order-2 xl:pr-0" >
          <a
            href="/account/"
            class="form-button text-gray-100/75 hover:text-gray-100/100 h-10 border border-primary-dark px-4 bg-primary-dark/50 hover:bg-primary-dark/100 flex items-center justify-center whitespace-nowrap"
            target="_blank"
          >Favorites ({{ numFavorites }})</a>
        </div>

        <div class="w-1/2 md:hidden pl-1.5 md:pl-3" >
          <span
            @click="toggleSortFilter"
            class="form-button text-gray-100/75 hover:text-gray-100/100 h-10 border border-primary-dark px-4 bg-primary-dark/50 hover:bg-primary-dark/100 flex items-center justify-center whitespace-nowrap"
            target="_blank"
          >Sort<span v-if="typeFilter || areaFilter" >/Filter</span></span>
        </div>

        <search-filters
          v-if="typeFilter || areaFilter"
          :type-filter="typeFilter"
          :area-filter="areaFilter"
          class="w-full md:w-auto xl:order-3 shrink md:pl-3  md:ml-auto"
          :class="{
            'hidden md:flex': !showSort,
            'block': showSort,
          }"
          :terms="params"
          @changed="setFilters"
          @submitted="performFilter"
        ></search-filters>

        <property-sort-form
          class="w-full md:w-auto md:order-4 md:pl-3 pt-3 md:pt-3 xl:pt-0"
          :class="{
            'hidden md:block': !showSort,
            'block': showSort,
          }"
          :terms="params"
          @sorted="performSort"
        ></property-sort-form>

        <p class="w-full md:w-1/2 xl:w-auto text-gray-700 dark:text-gray-300 px-3 pb-2 pt-4 md:py-2 grow md:order-3 xl:order-1 flex items-center" tabindex="0">
          <span v-if="meta.total > 36" >
            Showing {{ meta.count }} of {{ meta.total.toLocaleString() }} | page {{ meta.current_page }} of {{ meta.total_pages }}
          </span>
          <span v-else >
            Showing {{ meta.total }} results
          </span>
        </p>

      </div>
    </div>

    <div>
      <div ref="propertysearchresults" class="absolute -mt-40 z-0" ></div>
      <div v-if="!noresults && !loading" class="relative z-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 py-8" >
        <listing-card
          v-for="listing in listings"
          :key="listing.rets_listing_id"
          :listing="listing"
          :logged-in="loggedIn"
          :user="user"
          class="w-full"
          @set-favorite="updateFavorites"
        ></listing-card>
      </div>
      <div v-else class="m-0 text-center flex items-center justify-center">
        <div v-if="loading" class="flex items-center space-x-6 opacity-60 text-primary dark:text-white py-4 lg:py-8">
          <svg-vue icon="home" class="h-6 w-6 fill-current animate-spin" ></svg-vue>
          <p class="font-bold" >Loading Results...</p>
        </div>
        <slot v-if="noresults" />
      </div>
      <property-search-pagination
        v-if="meta.total > meta.per_page && !loading"
        :meta="meta"
        @first="paginate(1)"
        @prev="paginate(meta.current_page - 1)"
        @next="paginate(meta.current_page + 1)"
        @last="paginate(meta.total_pages)"
      ></property-search-pagination>
    </div>

  </div>
</template>
<script>
import PropertySearchForm from './PropertySearchForm.vue'
import PropertySearchPagination from './PropertySearchPagination.vue'
import PropertySortForm from './PropertySortForm.vue'
import SearchFilters from './SearchFilters.vue'
import ListingCard from './ListingCard.vue'

export default {
  name: "PropertySearch",

  props: {
    showForm: {
      type: Boolean,
      default: true
    },
    showMeta: {
      type: Boolean,
      default: true
    },
    typeFilter: {
      type: Boolean,
      default: false
    },
    areaFilter: {
      type: Boolean,
      default: false
    },
    terms: {
      type: Object,
      default: () => {}
    },
    loggedIn: {
      type: Boolean,
      default: false
    },
    user: {
      type: Number,
      default: null
    },
  },

  data () {
    return {
      endpoint: 'https://rets.kerigan.com/api/v2/listings',
      association: 'rafgc',
      loading: true,
      listings: {},
      params: {},
      meta: {},
      noresults: false,
      showSort: false,
      filtering: false,
      numFavorites: localStorage.getItem('favorites') ? JSON.parse(localStorage.getItem('favorites')).length : 0
    }
  },

  computed: {
    query () {
      let query = '?q=search'
      this.params.association = this.association

      for (const value in this.params) {
        query +=  this.params[value] != '' && this.params[value] != null && this.params[value] != undefined ? '&' + value + '=' + this.params[value] : ''
      }
      return query
    }
  },

  mounted () {
    if(this.terms != {}){
      this.params = this.terms
    }

    if (!localStorage.favorites) {
      localStorage.favorites = JSON.stringify([])
    }

    this.requestData()

    var paused = window.localStorage.getItem('paused')
    if (paused === 'true'){
      localStorage['paused'] = 'false'
    }
  },

  methods: {
    updateFavorites () {
      this.numFavorites = JSON.parse(localStorage.getItem('favorites')).length
    },

    performSearch (data) {
      let searchform = this
      this.params = data.params
      this.params.page = 1
      this.requestData()
      searchform.scrollToResults()
    },

    setFilters (data) {
      this.params.property_type = data.params.property_type ? data.params.property_type : ""
      this.params.region = data.params.region ? data.params.region : ""
      this.params.page = 1
    },

    performFilter () {

      this.filtering = true
      this.requestData()

      dataLayer.push({
        'event': 'user_action',
        'action_name': 'Filter Results',
        'area': this.params.region,
        'type': this.params.propertyType,
      })
    },

    performSort (data) {
      this.params.sort = data.sort
      this.params.page = 1
      this.requestData(true)

      dataLayer.push({
        'event': 'user_action',
        'action_name': 'Sort Results',
        'sort': this.params.sort,
      })
    },

    toggleSortFilter () {
      this.showSort = !this.showSort
    },

    paginate (page) {
      this.params.page = page
      this.requestData()
    },

    requestData () {
      this.listings = []
      this.loading = true
      let searchform = this

      fetch(this.endpoint + this.query, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(r => r.json())
        .then(response => {
            this.listings = response.data
            this.meta = response.meta.pagination
            this.loading = false
            this.noresults = false

            if(this.listings.length == 0){
              this.noresults = true
            }else{
              this.$emit('hasresults', this.params)
            }

        });
    },

    scrollToResults () {
      this.$nextTick(function () {
        this.$refs["propertysearchresults"].scrollIntoView({behavior: 'smooth'})
        // window.scrollTo({ behavior: 'smooth', top: this.$refs["propertysearchresults"] })
      })
    }
  },

  components: {
    PropertySearchForm,
    PropertySearchPagination,
    PropertySortForm,
    SearchFilters,
    ListingCard
  }
}
</script>
